import {
  NOTICE_OFF
} from './ActionTypes';

export const noticeOffRequest = () => {
  return (dispatch) => {
    dispatch(noticeOff());
  };
}

export const noticeOff = () => {
  return {
    type: NOTICE_OFF,
  }
}